export default "__VITE_ASSET__5b1e2045__"